<template>
  <div class="custom-main custom-theme">
    <a-spin :spinning="loading" tip="正在提交数据....">
      <a-row :gutter="{ xs: 8, sm: 16, md: 16}">
        <a-col :xs="1" :sm="1" :md="1" :lg="1" :xl="1" :xxl="1">&nbsp;</a-col>
        <a-col :xs="15" :sm="15" :md="15" :lg="15" :xl="15" :xxl="15">
          <a-form :form="form" layout="horizontal" style="margin-top: 20px">
            <a-row>
              <a-col span="8">
                <a-form-item :colon="false" label="处置名称" :label-col="{sm: 24, md: 12, lg: 12, xl: 12, xxl: 12 }" :wrapper-col="{sm: 24, md: 12, lg: 12, xl: 12, xxl: 12 }">
                  <a-input v-decorator="['name', {rules: [{ required: true, message: '处置名称必须填写!' }], initialValue: '' }]"  placeholder="请输入处置名称"/>
                </a-form-item>
              </a-col>
              <a-col span="8">
                <a-form-item :colon="false" label="英文名" :label-col="{sm: 24, md: 12, lg: 12, xl: 12, xxl: 12 }" :wrapper-col="{sm: 24, md: 12, lg: 12, xl: 12, xxl: 12 }">
                  <a-input v-decorator="['englishName']" placeholder="请输入处置英文名"/>
                </a-form-item>
              </a-col>
              <a-col span="8">
                <a-form-item :colon="false" label="标准编码" :label-col="{sm: 24, md: 12, lg: 12, xl: 12, xxl: 12 }" :wrapper-col="{sm: 24, md: 12, lg: 12, xl: 12, xxl: 12 }">
                  <a-input v-decorator="['code']" placeholder="请输入处置标准编码"/>
                </a-form-item>
              </a-col>
            </a-row>
            <a-row>
              <a-col span="8">
                <a-form-item :colon="false" label="单位" :label-col="{sm: 24, md: 12, lg: 12, xl: 12, xxl: 12 }" :wrapper-col="{sm: 24, md: 12, lg: 12, xl: 12, xxl: 12 }">
                  <a-input v-decorator="['unit', {rules: [{ required: true, message: '单位必须填写!' }], initialValue: '次' }]" placeholder="请输入单位"/>
                </a-form-item>
              </a-col>
              <a-col span="8">
                <a-form-item :colon="false" label="单价" :label-col="{sm: 24, md: 12, lg: 12, xl: 12, xxl: 12 }" :wrapper-col="{sm: 24, md: 12, lg: 12, xl: 12, xxl: 12 }">
                  <a-input-number :min="0" v-decorator="['price', {rules: [{ required: true, message: '单价必须填写!' }], initialValue: 1 }]" placeholder="请输入单价" />
                </a-form-item>
              </a-col>
              <a-col span="8">
                <a-form-item :colon="false" label="成本价" :label-col="{sm: 24, md: 12, lg: 12, xl: 12, xxl: 12 }" :wrapper-col="{sm: 24, md: 12, lg: 12, xl: 12, xxl: 12 }">
                  <a-input-number :min="0" v-decorator="['cost', {rules: [{ required: true, message: '成本价必须填写!' }], initialValue: 1 }]" placeholder="请输入成本价" />
                </a-form-item>
              </a-col>
            </a-row>
            <a-row>
              <a-col span="8">
                <a-form-item :colon="false" label="发票类型" :label-col="{sm: 24, md: 12, lg: 12, xl: 12, xxl: 12 }" :wrapper-col="{sm: 24, md: 12, lg: 12, xl: 12, xxl: 12 }">
                  <a-select v-decorator="['invoice']" placeholder="请选择发票类型">
                    <a-select-option value="">--请选择--</a-select-option>
                    <a-select-option v-for="item in init.invoices" :key="item.name" :value="item.name" >{{item.value}}</a-select-option>
                  </a-select>
                </a-form-item>
              </a-col>
              <a-col span="16">
                <a-form-item :colon="false" label="常用语" :label-col="{sm: 24, md: 6, lg: 6, xl: 6, xxl: 6 }" :wrapper-col="{sm: 24, md: 18, lg: 18, xl: 18, xxl: 18 }">
                  <a-select mode="tags" v-decorator="['alias']" placeholder="请输入处置常用语">
                  </a-select>
                </a-form-item>
              </a-col>
            </a-row>
            <a-row>
              <a-col span="24">
                <a-form-item :colon="false" label="注意事项" :label-col="{sm: 24, md: 4, lg: 4, xl: 4, xxl: 4 }" :wrapper-col="{sm: 24, md: 20, lg: 20, xl: 20, xxl: 20 }">
                  <a-textarea v-decorator="['notice']"  :auto-size="{ minRows: 3}"/>
                </a-form-item>
              </a-col>
            </a-row>
          </a-form>
          <div class="button-container">
            <div>
              <a-button icon="double-left" style="float:right; margin-left: 24px;" @click="goBack">返回</a-button>
              <a-button icon="save" type="primary" style="float:right; margin-left: 24px;" @click="()=>saveDispose()">保存</a-button>
            </div>
          </div>
        </a-col>
      </a-row>
    </a-spin>
  </div>
</template>

<script>
export default {
  name: "DisposeCreate",
  data(){
    return{
      loading:false,
      form: this.$form.createForm(this),
      init:{
        invoices:[]
      }
    }
  },
  beforeCreate() {
    let data = [
      {
        text: "首页",
        path: "",
      },{
        text: "医院管理",
        path: ""
      },
      {
        text: "耗材处置",
        path: "",
      },
      {
        text: "新增处置",
        path: "",
      },
    ];
    this.$store.commit("updateBreadcrumb", data);
  },
  mounted() {
    const self=this;

    this.getInvoiceTypes(function (res){
      self.init.invoices=res;
    })
  },
  methods:{
    saveDispose:function (){
      const self=this;

      this.form.validateFields((err, values) => {
        if(!err){
          let params={name:values.name,englishName:values.englishName,code:values.code,alias:values.alias,unit:values.unit,price:values.price,cost:values.cost,
            invoice:values.invoice,notice:values.notice}
          self.loading = true;
          self.$axios.post('/api/clinic/dispose/add', params).then(function(res){
            self.loading=false;
            if(res.msg.flag == 0){
              self.$message.success({content:'新增成功', duration: 2});
              self.form.resetFields();
            }else {
              self.$message.error({content: res.msg.message, duration: 2});
            }
          },function(res){
            self.loading = false;
          })
        }
      })
    },
    goBack:function (){
      this.$router.go(-1);
    }
  }
}
</script>

<style scoped>

</style>
